export const PhotoBackground = ({ src, eager = false }) => (
    <div className="absolute inset-0" aria-hidden="true">
        <img src={src} alt="" className="h-full w-full object-cover" loading={eager ? "eager" : "lazy"} />
        <div className="absolute inset-0 bg-[#070a0f]/35" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#070a0f]/95 via-[#070a0f]/80 to-[#070a0f]/55" />
    </div>
);
